const vagManufacturers = [
    5, // Audi
    92, // Porsche
    104, // Seat
    106, // Skoda
    121, // Volkswagen
    253, // VAG
    701, // Lamborghini
    788, // Bugatti
    815, // Bentley
]

export function isVAGManufacturer(manufactuerId: number) {
    return vagManufacturers.some((value) => value === manufactuerId)
}
